<template>
  <div class="gray-back page-ability-step1">
    <van-form
        ref="applyForm"
        @submit="onSubmit"
        @failed="onFailed"
    >
      <van-divider>个人能力申报</van-divider>
      <van-cell-group>
        <van-field
            readonly
            clickable
            right-icon="arrow"
            input-align="right"
            @click="showSaijiPicker=true"
            label="所属年份"
            v-model="saijiValue"
        />
        <van-popup v-model="showSaijiPicker" position="bottom">
          <van-picker :columns="saijiColumns"
                      show-toolbar
                      @cancel="showSaijiPicker = false"
                      @confirm="onSaijiConfirm"
          />
        </van-popup>
        <van-field
            readonly
            clickable
            right-icon="arrow"
            input-align="right"
            @click="showSaiquPicker=true"
            label="所属场次"
            v-model="saiquValue"
        />
        <van-popup v-model="showSaiquPicker" position="bottom" @open="onSaiquOpen">
          <van-picker :columns="saiquColumns"
                      show-toolbar
                      @cancel="showSaiquPicker = false"
                      @confirm="onSaiquConfirm"
          />
        </van-popup>
        <van-field
            readonly
            clickable
            name="area"
            :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
            input-align="right"
            label="邮寄地区"
            placeholder="点击选择省市区"
            @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>
        <van-field
            v-model="formData.danwei"
            :rules="[{ required: true, message: '单位名称不能为空' }]"
            label="单位全称"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请输入单位名称"
        />

        <van-field
            v-model="formData.ldname"
            label="联系人"
            :rules="[{ required: true, message: '姓名不能为空' }]"
            error-message-align="right"
            input-align="right"
            clearable
            placeholder="请输入姓名"
        />

        <van-field
            v-model="formData.phone"
            :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
            error-message-align="right"
            label="联系电话"
            input-align="right"
            clearable
            placeholder="请输入联系电话"
        />
        <van-field
            v-model="formData.weixin"
            :rules="[{ required: true, message: '微信不能为空' }]"
            error-message-align="right"
            label="微信"
            input-align="right"
            clearable
            placeholder="请输入微信"
        />
        <van-field
            v-model="formData.email"
            :rules="[{ validator: validator.email,message:'请输入正确的邮箱'} ]"
            error-message-align="right"
            label="邮箱"
            input-align="right"
            clearable
            placeholder="请输入邮箱"
        />
        <van-field
            v-model="formData.address"
            :rules="[{ required: true, message: '地址不能为空' }]"
            error-message-align="right"
            label="邮寄地址"
            input-align="right"
            clearable
            placeholder="请输入邮寄地址"
        />

        <van-field
            readonly
            clickable
            right-icon="arrow"
            input-align="right"
            label="人员选择"
            placeholder="请选择人员"
            @click="showYundongyuanPicker=true"
        />
        <YundongyuanPicker
            :show="showYundongyuanPicker"
            :limit="30"
            @onChange="onYundongyuanChange"
            @onClose="showYundongyuanPicker=false"
            :defaultValue="formData.yundongyuan"
            @onConfirm="onYundongyuanConfirm"
        />

        <div class="memberResultWrap" v-show="formData.yundongyuan.length>0">
          <div class="memberLi" v-for="(yundongyuan ,index) in formData.yundongyuan" :key="index">
            <van-tag
                round
                color="#fff"
                text-color="#666"
                size="large"
                closeable
                type="primary"
                @close="formData.yundongyuan.splice(index,1)"
            > {{ yundongyuan.name }}({{ yundongyuan.num }}) {{ yundongyuan.project }}-{{ yundongyuan.grade }}
            </van-tag>
          </div>
        </div>
      </van-cell-group>

      <div class="form-footer-space"/>
    </van-form>

    <div class="savebtn">
      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
          native-type="button"
          @click="submitForm"
      >保存
      </van-button>
    </div>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>

<style scoped>
.page-ability-step1 {
  min-height: 100vh;
  padding-bottom: 2rem;
  box-sizing: border-box;
}

.form-footer-space {
  height: 1.2rem;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}
</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import YundongyuanPicker from '@/components/picker/YundongyuanAbilityPicker.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  CellGroup,
  Form,
  Field,
  Toast,
  Dialog,
  Icon,
  Tag,
  Button,
  Divider,
  Popup,
  Picker,
  Area
} from 'vant';
import area from "../../../utils/area";

Vue.use(Cell).use(CellGroup).use(Form).use(Field).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button)
    .use(Divider).use(Popup).use(Picker).use(Area);

export default {
  name: 'AbilityApplyStep1',
  components: {
    YundongyuanPicker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      baomingId: 0,
      showArea: false,
      loginShow: false,
      showYundongyuanPicker: false,
      showSaijiPicker: false,
      showSaiquPicker: false,
      areaList: {},
      saijiColumns: [],
      saiquColumns: [],
      formData: {
        saiji: '',
        saiqu: '',
        ldname: '',
        danwei: '',
        namekey: '',
        province: '',
        city: '',
        county: '',
        area: '',
        phone: '',
        weixin: '',
        email: '',
        address: '',
        yundongyuan: []
      },
      saveLoading: false,
      saijiValue: '',
      saiquValue: '',
    }
  },
  mounted() {
    document.title = '能力测试 · 第一步';
    this.areaList = area;
    const qid = this.$route.query.id;
    this.baomingId = qid ? parseInt(qid, 10) : 0;
    if (isNaN(this.baomingId)) {
      this.baomingId = 0;
    }
    this.getOptions();
    this.fetchStep1Detail();
  },
  methods: {
    getOptions() {
      const that = this;
      that.$api.get('/api/ability/saijiOptions', {}, (res) => {
        that.saijiColumns = res.data;
      }, (res) => {
        if (res.code === 401 || res.code === 402) {
          if (window.isApp()) {
            rbLink({ name: 'login', query: {} }, 'replace');
            return;
          }
          that.loginShow = true;
        } else {
          Toast(res.msg);
        }
      });
    },

    getSaiquOptions() {
      const that = this;
      if (!that.formData.saiji) {
        that.saiquColumns = [];
        return;
      }
      that.$api.get('/api/ability/saiquOptions', {
        saiji: that.formData.saiji
      }, (res) => {
        that.saiquColumns = res.data;
      });
    },

    fetchStep1Detail() {
      const that = this;
      that.$api.get('/api/ability/step1Detail', {
        id: that.baomingId
      }, (res) => {
        const d = res.data;
        that.baomingId = d.id || 0;
        that.formData.ldname = d.ldname || '';
        that.formData.danwei = d.danwei || '';
        that.formData.namekey = d.namekey || '';
        that.formData.province = d.province || '';
        that.formData.city = d.city || '';
        that.formData.county = d.county || '';
        that.formData.area = d.area || d.namekey || '';
        that.formData.phone = d.phone || '';
        that.formData.weixin = d.weixin || '';
        that.formData.email = d.email || '';
        that.formData.address = d.address || '';
        that.formData.saiji = d.saiji || '';
        that.formData.saiqu = d.saiqu || '';
        that.saijiValue = d.saiji_text || '';
        that.saiquValue = d.saiqu_text || '';
        that.formData.yundongyuan = Array.isArray(d.yundongyuan) ? d.yundongyuan : [];
        if (that.formData.saiji) {
          that.getSaiquOptions();
        }
      }, (res) => {
        if (res.code === 401 || res.code === 402) {
          if (window.isApp()) {
            rbLink({ name: 'login', query: {} }, 'replace');
            return;
          }
          that.loginShow = true;
        } else {
          Toast.fail(res.msg || '加载失败');
        }
      });
    },

    loginSuccess() {
      this.loginShow = false;
      this.fetchStep1Detail();
    },

    loginCancel() {
    },

    onYundongyuanConfirm(values) {
      this.showYundongyuanPicker = false;
      this.formData.yundongyuan = [...values];
    },
    onYundongyuanChange(values) {
      this.formData.yundongyuan = [...values];
    },

    onAreaConfirm(values) {
      this.formData.namekey = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.formData.area = values[2].code;
      this.showArea = false;
    },

    onSaijiConfirm(value) {
      this.formData.saiji = value.id;
      this.saijiValue = value.text;
      this.saiquValue = '';
      this.formData.saiqu = '';
      this.getSaiquOptions();
      this.showSaijiPicker = false;
    },

    onSaiquOpen() {
      if (!this.formData.saiji) {
        Toast('请先选择所属年份');
      }
    },

    onSaiquConfirm(value) {
      this.showSaiquPicker = false;
      if (value === undefined) return;
      this.formData.saiqu = value.id;
      this.saiquValue = value.text;
    },

    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },

    submitForm() {
      if (!this.formData.namekey) {
        Toast('请选择所属地区');
        return;
      }
      if (!this.formData.saiji) {
        Toast('请选择所属年份');
        return;
      }
      if (!this.formData.saiqu) {
        Toast('请选择所属场次');
        return;
      }
      if (!this.formData.yundongyuan.length) {
        Toast('请选择人员');
        return;
      }
      const form = this.$refs.applyForm;
      if (form && typeof form.validate === 'function') {
        form.validate().then(() => {
          this.doSave();
        }).catch(() => {});
      } else {
        this.doSave();
      }
    },

    onSubmit() {
      this.doSave();
    },

    doSave() {
      const that = this;
      const payload = Object.assign({}, that.formData, {
        id: that.baomingId
      });
      that.saveLoading = true;
      that.$api.post('/api/ability/abilityApply', payload, (res) => {
        that.saveLoading = false;
        Toast.success('保存成功');
        const newId = (res.data && res.data.id) ? res.data.id : that.baomingId;
        rbLink({ name: 'AbilityApplyStep2', query: { id: newId } }, 'replace');
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// AbilityApplyStep1.vue?0c289305